module.exports = __webpack_public_path__ + "static/media/1012248.3de18907.jpg";